import { getOrderList } from "api/order";
import { isBeforetwelveandsix, convertDateTime } from "Helpers/date";
import { useLastOrderEditPath } from "Hooks/useLastOrderEditPath";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import EditIcon from "../../../Assets/images/edit.svg";
import ViewIcon from "../../../Assets/images/error-outline.svg";
// Components
import Header from "../../../Components/Header/Header";
import ReactTable from "../../../Components/Table/Table";
import { AppContext } from "../../../Context/AppContext";
import { MODULES } from "../../../Helpers/Constants";
import { formatUsPhone } from "../../../Hooks/commanUtility";
// Context
import { getAccessByModuleName } from "../../../Routes/Routes";
//scss
import styles from "./index.module.scss";
import LoadingScreen from "Components/Loading/LoadingScreen";
import { setAllStore } from "Helpers/setAllStore";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";

const Orders = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const navigate = useNavigate();
  // Add / Edit
  const [access, setAccess] = useState({});
  const [type, setType] = useState("delivery_date");

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [firstRender, setFirstRender] = useState(true);
  const [columnStateSaveData, setColumnStateSaveData] = useState({});

  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });

  const [fromDate, setFromDate] = useState(
    moment().startOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [selectedPeriod, setSelectedPeriod] = React.useState("weekly");
  const [selectedPeriodLabel, setSelectedPeriodLabel] = React.useState(
    "By Week"
  );

  const [checkAllStore,setCheckAllStore] = useState(true);


  // Set Async Data
  const setAsyncData = (data) => {
    let asyncDataValuesPendingOrder = JSON.stringify(data);
    localStorage.setItem(
      "asyncDataValuesPendingOrder",
      asyncDataValuesPendingOrder
    );
  };

  // Get And Set Data Into State
  useEffect(() => {
    const filterData = JSON.parse(
      localStorage.getItem("asyncDataValuesPendingOrder")
    );
    if (filterData) {
      const {
        currentPage,
        itemsPerPage,
        globalSearch,
        filters,
        sortBy,
        date_type,
        start_date,
        end_date,
        selectedPeriodLabel,
        selectedPeriod,
      } = filterData;
      setDefaultFilter({
        filters: filters,
        pageIndex: currentPage,
        globalFilter: globalSearch,
        pageSize: itemsPerPage,
        sortBy: sortBy,
      });
      setType(date_type);
      setFromDate(moment(start_date).format("ddd MMM DD, YYYY"));
      setToDate(moment(end_date).format("ddd MMM DD, YYYY"));
      setSelectedPeriodLabel(selectedPeriodLabel);
      setSelectedPeriod(selectedPeriod);
    }
    setFirstRender(false);

    const columnStateData = JSON.parse(localStorage.getItem("columnDataStateSavePendingOrder"));
    setColumnStateSaveData(columnStateData);
  }, []);

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
  }) => {

    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
      setAllStore(checkAllStore);

    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setLoading(true);
    const postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
      date_type: type,
      start_date: moment(fromDate).format("YYYY-MM-DD"),
      end_date: moment(toDate).format("YYYY-MM-DD"),
      list_type: "pending",
    };

    let pendingAccess = getAccessByModuleName(modules, MODULES.PENDING_ORDER);
    if (pendingAccess && pendingAccess.permissions.read_access) {
      const response = await getOrderList(postData);
      if (response && response.status === 200) {
        setData(response.data.data.rows);
        setPageCount(Math.ceil(response.data.data.count / pageSize));
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
    }
    setAsyncData({
      ...postData,
      selectedPeriod: selectedPeriod,
      selectedPeriodLabel: selectedPeriodLabel,
    });
    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if(checkAllStore){ setAllStore(false) }
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();

    setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
    setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
    setSelectedPeriod("weekly");

    fetchData(defaultFilter);
  };





  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);
  useLastOrderEditPath();
  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.PENDING_ORDER);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }

  const selectedColumn = async (column) => {
    let columnData = JSON.stringify(column);
    localStorage.setItem("columnDataStateSavePendingOrder", columnData);
  };

  let accountAccess = getAccessByModuleName(modules, MODULES.ACCOUNT_LOOKUP);
  let viewOrderAccess = getAccessByModuleName(modules, MODULES.VIEW_ORDER);
  const columns = React.useMemo(
    () => [
      {
        Header: "Order No",
        accessor: "order_number",
        isVisible: columnStateSaveData?.order_number ?? true,
        placeholder: "Order No",
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        isVisible: columnStateSaveData?.customer_name ?? true,
        placeholder: "Customer Name",
        Cell: ({ value, row, column }) => {
          return row.original.order_transaction.customer_id === 0 ||
            row.original.order_transaction.customer_id === undefined ? (
            <span style={{textTransform: 'capitalize'}}>{`${row.original.order_transaction.customer_name}`}</span>
          ) : accountAccess && accountAccess.permissions.write_access ? (
            <Link
              to={`/admin/customers/${row.original.order_transaction.customer_id}`}
            >
              <span className={`cursor-pointer`} style={{textTransform: 'capitalize'}}>
                {`${row.original.order_transaction.customer_name}`}
              </span>
            </Link>
          ) : (
            <span style={{textTransform: 'capitalize'}}>{`${row.original.order_transaction.customer_name}`}</span>
          );
        },
      },
      {
        Header: "Recipient Name",
        accessor: "recipient_name",
        isVisible: columnStateSaveData?.recipient_name ?? true,
        placeholder: "Recipient Name",
        Cell: ({ value, row, column }) => {
          return `${row.original.order_recipients[0].recipient_name}`;
        },
      },
      {
        Header: "Order Date",
        accessor: "createdAt",
        isVisible: columnStateSaveData?.createdAt ?? true,
        placeholder: "Order Date",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.createdAt && row.original.createdAt !== null
              ? convertDateTime(row.original.createdAt, 'iso', "ccc LLL dd, yyyy, hh:mm a")
              : ""
          }`;
        },
        disableFilters: true,
      },
      {
        Header: "Delivery Date",
        accessor: "delivery_date_time",
        isVisible: columnStateSaveData?.delivery_date_time ?? true,
        placeholder: "Delivery Date",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.delivery_date_time &&
            row.original.delivery_date_time !== null
              ? row.original.delivery_time_type === "Anytime"
                ? convertDateTime(row.original.delivery_date_time, 'iso', "ccc LLL dd, yyyy") +
                  " " +
                  row.original.delivery_time_type
                : convertDateTime(row.original.delivery_date_time, 'iso', "ccc LLL dd, yyyy, hh:mm a")
              : ""
          }`;
        },
        disableFilters: true,
      },
      {
        Header: "Building Type",
        accessor: "building_type",
        isVisible: columnStateSaveData?.building_type ?? true,
        placeholder: "Building Type",
        colWidth: 140,
        isSelectFilter: true,
        selectFilterOption: [
          { id: "", title: "All" },
          { id: "house", title: "House" },
          { id: "apartment", title: "Apartment" },
          { id: "business", title: "Business" },
          { id: "funeral_home", title: "Funeral home" },
          { id: "church", title: "Church" },
          { id: "hospital", title: "Hospital" },
          { id: "restaurant", title: "Restaurant" },
          { id: "hotel", title: "Hotel" },
          { id: "university", title: "University" },
          { id: "other_school ", title: "Other school " },
        ],
        Cell: ({ value, row, column }) => {
          return `${row.original.order_recipients[0].building_type}`;
        },
      },
      {
        Header: "Price",
        accessor: "total",
        isVisible: columnStateSaveData?.total ?? true,
        placeholder: "Price",
        Cell: ({ value, row, column }) => {
          return `$${row.original.total.toFixed(2)}`;
        },
      },
      {
        Header: "Products",
        accessor: "image",
        isVisible: columnStateSaveData?.image ?? true,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          let time = isBeforetwelveandsix(row.original.delivery_date_time);
          let threeMark = (
            <span
              className={` ${styles.ProducatBadge} ${styles.ProducatBadgeRed}`}
            >
              !!!
            </span>
          );

          let oneMark = (
            <span
              className={` ${styles.ProducatBadge} ${styles.ProducatBadgeGreen}`}
            >
              !
            </span>
          );
          let img = row.original.order_products.find((c) => !c.product_type);
          return (
            <div className={` ${styles.ProducatImageWapper}`}>
              <img
                src={
                  img?.variation_image === "" ||
                  img?.variation_image === "null" ||
                  img?.variation_image === null
                    ? ""
                    : `${img.variation_image}`
                }
                alt=""
              />
              {time.beforTwelve && threeMark}
              {!time.beforTwelve && time.beforSix && oneMark}
            </div>
          );
        },
      },
      {
        Header: "Customer Email",
        accessor: "customer_email",
        placeholder: "Customer Email",
        isVisible: columnStateSaveData?.customer_email ?? false,
        Cell: ({ value, row, column }) => {
          return `${row.original.order_transaction.customer_email}`;
        },
      },
      {
        Header: "Customer Phone",
        accessor: "customer_phone",
        placeholder: "Customer Phone",
        isVisible: columnStateSaveData?.customer_phone ?? false,
        Cell: ({ value, row, column }) => {
          return `${
            row.original.order_transaction.customer_phone
              ? row.original.order_transaction.customer_phone_country_code +
                " " +
                formatUsPhone(row.original.order_transaction.customer_phone)
              : ""
          }`;
        },
      },
      {
        Header: "Recipient Phone",
        accessor: "recipient_phone",
        placeholder: "Recipient Phone",
        isVisible: columnStateSaveData?.recipient_phone ?? false,
        Cell: ({ value, row, column }) => {
          return `${
            row.original.order_recipients[0].recipient_phone
              ? row.original.order_recipients[0].phone_country_code +
                " " +
                formatUsPhone(row.original.order_recipients[0].recipient_phone)
              : ""
          }`;
        },
      },
      {
        Header: "Customer Address",
        accessor: "customer_address",
        placeholder: "Customer Address",
        isVisible: columnStateSaveData?.customer_address ?? false,
        Cell: ({ value, row, column }) => {
          return `${row.original.order_transaction.customer_address}`;
        },
      },
      {
        Header: "Recipient Address",
        accessor: "recipient_address",
        placeholder: "Recipient Address",
        isVisible: columnStateSaveData?.recipient_address ?? false,
        Cell: ({ value, row, column }) => {
          return `${row.original.order_recipients[0].recipient_address}`;
        },
      },
      {
        Header: "Status",
        accessor: "order_status",
        placeholder: "Status",
        disableFilters: true,
        disableSortBy: true,
        isVisible: columnStateSaveData?.order_status ?? false,
      },
      {
        Header: "Type",
        accessor: "source",
        placeholder: "Type",
        isVisible: columnStateSaveData?.source ?? false,
      },
      {
        Header: "External Order Number",
        accessor: "external_order_number",
        placeholder: "External Order Number",
        isVisible: columnStateSaveData?.external_order_number ?? false,
      },
      {
        Header: "Actions",
        accessor: "id",
        isVisible: columnStateSaveData?.id ?? true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {viewOrderAccess && viewOrderAccess.permissions.read_access ? (
                <Link to={`/admin/orders/view/${row.original.id}`}>
                  <img
                    className={`cursor-pointer view-icon`}
                    src={ViewIcon}
                    alt="View Order"
                  />
                </Link>
              ) : (
                <span style={{ width: 34, height: 34, display: "block" }} />
              )}
              {row?.original?.old_order_number === 0 && (
                <Link to={`/admin/orders/edit/${row.original.id}`}>
                  <img
                    className={`cursor-pointer mr-2`}
                    src={EditIcon}
                    alt="Edit Order"
                  />
                </Link>
              )}
            </div>
          );
        },
      },
    ],
    [columnStateSaveData]
  );

  const selectedPeriodOptions = [
    { id: "weekly", title: "Weekly" , label: "By Week" },
    { id: "monthly", title: "Monthly" , label: "By Month" },
    { id: "yearly", title: "Yearly" , label: "By Year" },
  ];

  if (firstRender) return <LoadingScreen />;
  return (
    <React.Fragment>
      <Header title="Pending Order" />

      <div id="MainContent" className="main-content">

      <GlobalDateFilters
        isClearSearchBtn
        isSearchIcon
        isDateFilter
        isAllCheckStoreBnt
        isFilterByOption
        isFilterByPeriod
        isSelectedPeriodLabel
        fetchData={() => {
          fetchData({
            ...defaultFilter,
          });
        }}
        setType={setType}
        type={type}
        fromDate={fromDate}
        toDate={toDate}
        setToDate={setToDate}
        setFromDate={setFromDate}
        handleClearSearch={handleClearSearch}
        defaultSetCheckAllStore={checkAllStore}
        checkAllStore={(data)=>{setCheckAllStore(data)}}
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        periodOptions={selectedPeriodOptions}
        selectedPeriodLabel={selectedPeriodLabel}
        setSelectedPeriodLabel={setSelectedPeriodLabel}
        dateFormate={"YYYY-MM-DD"}
        key={"pending-order"}
      />
        <ReactTable
          columns={columns}
          data={data}
          fetchData={fetchData}
          loading={loading}
          pageCount={pageCount}
          noDataText={"There is no data to display"}
          defaultFilter={defaultFilter}
          displayGlobalSearch={false}
          displayColumnVisibility={true}
          selectedColumn={selectedColumn}
        />
      </div>
    </React.Fragment>
  );
};

export default Orders;
